export default __webpack_public_path__ + "static/logo-propdata-white-d9cc5ecbf01b231fd698af7f76122b8a.png";